/* eslint-disable arrow-body-style */
<template>
  <b-overlay
    id="overlay-background"
    :show="dataLoading"
    variant="light"
    opacity="0.30"
    blur="10px"
    rounded="sm"
  >
    <div>
      <div
        v-for="block in displayBlocks"
        :key="block.id"
      >
        <b-card class="rate-card-toolbar">
          <b-row class="align-items-end">
            <b-col
              cols="6"
              md="3"
              class="mobile-width-fix mb-1 mb-lg-0"
            >
              <b-form-group
                :label-for="`rate-card-name-${block.id}`"
                class="mb-0"
              >
                <template #label>
                  <span class="d-inline-flex align-items-center">
                    Rate Card Name
                    <b-badge
                      v-if="block.id === 'default'"
                      variant="light-success"
                      class="rate-card-kind-badge"
                    >
                      Default
                    </b-badge>
                    <b-badge
                      v-else
                      variant="light-warning"
                      class="rate-card-kind-badge"
                    >
                      Service Type
                    </b-badge>
                  </span>
                </template>
                <b-form-input
                  :id="`rate-card-name-${block.id}`"
                  :value="block.id === 'default' ? rateCardName : block.cardName"
                  placeholder="Rate Card Name"
                  autocomplete="nope"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              class="d-none d-md-block"
            />
            <b-col
              cols="6"
              md="3"
              class="mobile-width-fix d-flex justify-content-end align-items-end rate-card-toolbar-actions"
            >
              <b-form-checkbox
                :key="`tv-switch-${block.id}`"
                :checked="block.isTableView"
                :name="`table-view-switch-${block.id}`"
                switch
                inline
                class="mb-0"
                @change="val => onBlockTableView(block.id, val)"
              >
                <span
                  :class="block.isTableView? 'font-weight-bold' : 'text-muted font-weight-bold' "
                >
                  Table View
                </span>
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-card>
        <div v-if="block.isTableView">
          <rate-card-table-view
            :key="`tv-${block.id}-${block.linear.length}-${block.bucket.length}`"
            :linear_sections="block.linear"
            :bucket_sections="block.bucket"
            :city-list="CityList"
            :zone-list="ZoneList"
          />
        </div>
        <div v-if="!block.isTableView">
          <div>
            <b-card
              v-for="(section, section_index) in block.linear"
              :key="`${block.id}-linear-${section_index}`"
            >
              <div>
                <b-row>
                  <b-col md="3">
                    <span class="font-weight-bold">Section #{{ block.linearOffset + section_index + 1 }} - {{ section.is_service_type ? 'Service Type' : section.section_type }} Rate Card #{{ block.linearOffset + section_index + 1 }}</span>
                  </b-col>
                  <b-col md="3" />
                  <b-col md="3" />
                  <b-col md="3" />
                </b-row>
                <b-row
                  v-if="section.show_service_type"
                  class="service-type-row"
                >
                  <b-col
                    cols="6"
                    lg="3"
                    class="mobile-width-fix"
                  >
                    <b-form-group
                      label="Service Type"
                      :label-for="`linear-service-type-${block.id}`"
                    >
                      <v-select
                        :id="`linear-service-type-${block.id}`"
                        :value="section.service_type_name"
                        :options="[{ name: section.service_type_name }]"
                        label="name"
                        placeholder="Select Service Type"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <span
                      style="visibility: hidden"
                    >Spacing for 1 row</span>
                  </b-col>
                  <b-col md="3" />
                </b-row>
              </div>
              <div>
                <ValidationObserver
                  ref="createCityForm"
                  slim
                >
                  <b-form
                    class="my-8 border border-dimgray rounded"
                  >
                    <div class="rate-card-block-label ml-1 mt-1">
                      Delivery Charges
                    </div>
                    <b-row class="mt-50 mr-1 ml-1">
                      <b-col
                        cols="6"
                        lg="3"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          label="Delivery Method"
                          label-for="v-name"
                        >
                          <v-select
                            v-model="section.amount.delivery_method"
                            :options="liearpricingMethod"
                            label="name"
                            :reduce="option => option.value"
                            placeholder="Select Method"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="section.amount.delivery_method === 'per_kg'"
                        cols="6"
                        lg="3"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          v-b-tooltip.hover.top="'Delivery Charge Margin (kg)'"
                          label="Delivery Charge Margin"
                          label-for="v-del-ao"
                        >
                          <b-form-input
                            id="delivery_weight_margin"
                            v-model="section.amount.delivery_weight_margin"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="section.amount.delivery_method === 'per_kg'"
                        cols="6"
                        lg="3"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          label="Delivery Charge Margin Rate"
                          label-for="v-ret-ao"
                        >
                          <b-form-input
                            id="delivery_weight_margin_rate"
                            v-model="section.amount.delivery_weight_margin_rate"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="section.amount.delivery_method === 'per_kg'"
                        cols="6"
                        lg="3"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          label="Delivery Charge After Margin Rate"
                          label-for="v-ret-ao"
                        >
                          <b-form-input
                            id="delivery_weight_after_margin_rate"
                            v-model="section.amount.delivery_weight_after_margin_rate"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="section.amount.delivery_method === 'per_order'"
                        cols="2"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          label="Delivery Charge"
                          label-for="v-ret-ao"
                        >
                          <b-form-input
                            id="delivery_rate"
                            v-model="section.amount.delivery_rate"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div class="rate-card-block-label ml-1">
                      Return Charges
                    </div>
                    <b-row class="mt-50 mr-1 ml-1">
                      <b-col
                        cols="6"
                        lg="3"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          label="Return Method"
                          label-for="v-name"
                        >
                          <v-select
                            v-model="section.amount.return_method"
                            :options="liearpricingMethod"
                            label="name"
                            :reduce="option => option.value"
                            placeholder="Select Method"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="section.amount.return_method === 'per_kg'"
                        cols="6"
                        lg="3"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          v-b-tooltip.hover.top="'Return Charge Margin (kg)'"
                          label="Return Charge Margin"
                          label-for="v-del-ao"
                        >
                          <b-form-input
                            id="return_weight_margin"
                            v-model="section.amount.return_weight_margin"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="section.amount.return_method === 'per_kg'"
                        cols="6"
                        lg="3"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          label="Return Charge Margin Rate"
                          label-for="v-ret-ao"
                        >
                          <b-form-input
                            id="return_weight_margin_rate"
                            v-model="section.amount.return_weight_margin_rate"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="section.amount.return_method === 'per_kg'"
                        cols="6"
                        lg="3"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          label="Return Charge After Margin Rate"
                          label-for="v-ret-ao"
                        >
                          <b-form-input
                            id="return_weight_after_margin_rate"
                            v-model="section.amount.return_weight_after_margin_rate"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="section.amount.return_method === 'per_order'"
                        cols="2"
                        class="mobile-width-fix"
                      >
                        <b-form-group
                          label="Return Charge"
                          label-for="return_rate"
                        >
                          <b-form-input
                            id="return_rate"
                            v-model="section.amount.return_rate"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3">
                        <span
                          style="visibility: hidden"
                        >Spacing for 1 row</span>
                      </b-col>
                      <b-col md="3" />
                    </b-row>
                  </b-form>
                  <b-row>
                    <b-col md="3">
                      <span
                        style="visibility: hidden"
                      >Spacing for 1 row</span>
                    </b-col>
                    <b-col md="3" />
                  </b-row>
                  <div class="rate-card-block-label ml-1">
                    Origin/Destination Configuration
                  </div>
                  <div>
                    <div
                      v-for="(city, city_index) in section.cities"
                      :key="city_index"
                      class="border border-dimgray rounded mb-1 px-1 pt-1"
                    >
                      <b-row class="align-items-end">
                        <b-col md="4">
                          <b-form-group
                            label="Origin"
                            label-for="item-name"
                          >
                            <v-select
                              v-model="city.from_type"
                              :options="originMethods"
                              label="title"
                              autocomplete="nope"
                              placeholder="City/Zone"
                              disabled
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                            label="End"
                            label-for="item-name"
                          >
                            <v-select
                              v-model="city.to_type"
                              :options="originMethods"
                              label="title"
                              autocomplete="nope"
                              placeholder="City/Zone"
                              disabled
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          md="4"
                          class="d-flex align-items-center mb-1"
                        >
                          <b-form-checkbox
                            v-model="city.is_bidirectional"
                            v-b-tooltip.hover.v-danger
                            title="Check this if only direction is Bidirectional"
                            class="mb-0"
                            value="true"
                            disabled
                          >
                            Bidirectional
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4">
                          <b-form-group
                            label="Origin City"
                            label-for="item-name"
                          >
                            <v-select
                              v-model="city.from_city"
                              :options="(city.from_type === 'city' )? CityList : ZoneList"
                              :reduce="option => option.id"
                              label="name"
                              autocomplete="nope"
                              placeholder="Select City/Zone"
                              disabled
                            >
                              <template v-slot:option="option">
                                {{ option.name }}
                              </template>
                            </v-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                            label="Destination City"
                            label-for="item-name"
                          >
                            <v-select
                              v-model="city.to_cities"
                              :options="(city.to_type === 'city' )? CityList : ZoneList"
                              :reduce="option => option.id"
                              label="name"
                              autocomplete="nope"
                              placeholder="Select City/Zone"
                              multiple
                              deselect-from-dropdown
                              style="background-color: #f0f0f0;"
                            >
                              <template
                                v-slot:option="option"
                              >
                                {{ option.name }}
                              </template>
                            </v-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </b-card>
          </div>
        </div>
        <!-- End Linear Rate Card Section -->
        <!-- Start Bucket Rate Card Section -->
        <div v-if="!block.isTableView">
          <div>
            <b-card
              v-for="(section, section_index) in block.bucket"
              :key="`${block.id}-bucket-${section_index}`"
            >
              <div>
                <b-row>
                  <b-col md="3">
                    <span class="font-weight-bold">Section #{{ block.bucketOffset + section_index + 1 }} - {{ section.is_service_type ? 'Service Type' : section.section_type }} Rate Card #{{ block.bucketOffset + section_index + 1 }}</span>
                  </b-col>
                  <b-col md="3" />
                  <b-col md="2" />
                  <b-col md="3">
                    <v-select
                      v-model="section.amount.method"
                      :options="bucketPricingMethods"
                      :reduce="option => option.value"
                      label="name"
                      autocomplete="nope"
                      placeholder="Pricing Method"
                      disabled
                    />
                  </b-col>
                </b-row>
                <b-row
                  v-if="section.show_service_type"
                  class="service-type-row"
                >
                  <b-col
                    cols="6"
                    lg="3"
                    class="mobile-width-fix"
                  >
                    <b-form-group
                      label="Service Type"
                      :label-for="`bucket-service-type-${block.id}`"
                    >
                      <v-select
                        :id="`bucket-service-type-${block.id}`"
                        :value="section.service_type_name"
                        :options="[{ name: section.service_type_name }]"
                        label="name"
                        placeholder="Select Service Type"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <span
                      style="visibility: hidden"
                    >Spacing for 1 row</span>
                  </b-col>
                  <b-col md="3" />
                </b-row>
              </div>
              <div>
                <ValidationObserver
                  ref="createCityForm"
                  slim
                >
                  <b-form
                    class="my-8 border border-dimgray rounded"
                  >
                    <b-row>
                      <b-col md="3">
                        <span
                          style="visibility: hidden"
                        >Spacing for 1 row</span>
                      </b-col>
                      <b-col md="3" />
                    </b-row>
                    <b-row
                      v-for="(weight, weight_index) in section.amount.weights"
                      :key="weight_index"
                    >
                      <b-col
                        cols="1"
                      />
                      <b-col cols="3">
                        <b-form-group
                          label="From"
                          label-for="v-del-ao"
                        >
                          <b-form-input
                            id="v-del-ao"
                            v-model="weight.from"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="3">
                        <b-form-group
                          label="To"
                          label-for="v-del-ao"
                        >
                          <b-form-input
                            id="v-del-ao"
                            v-model="weight.to"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="2">
                        <b-form-group
                          label="Delivery Amount"
                          label-for="v-ret-ao"
                        >
                          <b-form-input
                            id="v-ret-ao"
                            v-model="weight.delivery_amount"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="2">
                        <b-form-group
                          label="Return Amount"
                          label-for="v-ret-ao"
                        >
                          <b-form-input
                            id="v-ret-ao"
                            v-model="weight.return_amount"
                            type="number"
                            autocomplete="nope"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3">
                        <span
                          style="visibility: hidden"
                        >Spacing for 1 row</span>
                      </b-col>
                      <b-col md="3" />
                    </b-row>
                  </b-form>
                  <b-row>
                    <b-col md="3">
                      <span
                        style="visibility: hidden"
                      >Spacing for 1 row</span>
                    </b-col>
                    <b-col md="3" />
                  </b-row>
                  <div class="rate-card-block-label ml-1">
                    Origin/Destination Configuration
                  </div>
                  <div>
                    <div
                      v-for="(city, city_index) in section.cities"
                      :key="city_index"
                      class="border border-dimgray rounded mb-1 px-1 pt-1"
                    >
                      <b-row class="align-items-end">
                        <b-col md="4">
                          <b-form-group
                            label="Origin"
                            label-for="item-name"
                          >
                            <v-select
                              v-model="city.from_type"
                              :options="originMethods"
                              label="title"
                              autocomplete="nope"
                              placeholder="City/Zone"
                              disabled
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                            label="End"
                            label-for="item-name"
                          >
                            <v-select
                              v-model="city.to_type"
                              :options="originMethods"
                              label="title"
                              autocomplete="nope"
                              placeholder="City/Zone"
                              disabled
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          md="4"
                          class="d-flex align-items-center mb-1"
                        >
                          <b-form-checkbox
                            v-model="city.is_bidirectional"
                            v-b-tooltip.hover.v-danger
                            title="Check this if only direction is Bidirectional"
                            class="mb-0"
                            value="true"
                            disabled
                          >
                            Bidirectional
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4">
                          <b-form-group
                            label="Origin City"
                            label-for="item-name"
                          >
                            <v-select
                              v-model="city.from_city"
                              :options="(city.from_type === 'city' )? CityList : ZoneList"
                              :reduce="option => option.id"
                              label="name"
                              autocomplete="nope"
                              placeholder="Select City/Zone"
                              disabled
                            >
                              <template v-slot:option="option">
                                {{ option.name }}
                              </template>
                            </v-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                            label="Destination City"
                            label-for="item-name"
                          >
                            <v-select
                              v-model="city.to_cities"
                              :options="(city.to_type === 'city' )? CityList : ZoneList"
                              :reduce="option => option.id"
                              label="name"
                              autocomplete="nope"
                              placeholder="Select City/Zone"
                              multiple
                              deselect-from-dropdown
                              style="background-color: #f0f0f0"
                            >
                              <template
                                v-slot:option="option"
                              >
                                {{ option.name }}
                              </template>
                            </v-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BForm,
  BRow,
  VBModal,
  BFormInput,
  BOverlay,
  BFormCheckbox,
  BBadge,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { heightTransition } from '@core/mixins/ui/transition'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import { isServiceTypeFeatureOn } from '@/helpers/serviceTypeFeature'
import RateCardTableView from './rateCardTableView.vue'

const ResourceRepository = RepositoryFactory.get('resource')
const ResourceBusinessSettingRepository = RepositoryFactory.get('businessSettings')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')

export default {
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BCol,
    BFormGroup,
    BForm,
    BOverlay,
    BRow,
    vSelect,
    BFormInput,
    BCard,
    BFormCheckbox,
    BBadge,
    RateCardTableView,
  },
  mixins: [SuccessMessage, ErrorMessage, heightTransition],
  data() {
    return {
      loading: false,
      dataLoading: false,
      form: {},
      rows: null,
      rateCardName: '',
      originMethods: ['city', 'zone'],
      liearpricingMethod: [
        { name: 'Per Kg', value: 'per_kg' },
        { name: 'Per Order', value: 'per_order' },
      ],
      bucketPricingMethods: [
        { name: 'Per Kg', value: 'per_kg' },
      ],
      CityList: [],
      ZoneList: [],
      // Start Section
      linear_sections: [
        {
          section_type: 'linear',
          amount: {
            delivery_method: 'per_kg',
            delivery_weight_margin: '0',
            delivery_weight_margin_rate: '0',
            delivery_weight_after_margin_rate: '0',
            return_method: 'per_kg',
            return_weight_margin: '0',
            return_weight_margin_rate: '0',
            return_weight_after_margin_rate: '0',
          },
          cities: [
            {
              from_type: '',
              from_city: '',
              to_type: '',
              to_city: '',
              to_cities: [],
              is_bidirectional: '',
            },
          ],
        },
      ],
      bucket_sections: [],
      // End Section
      direction: ['Bidirectional', 'Unidirectional'],
      id: null,
      tableViewByBlock: {
        default: false,
      },
      orderSettings: {},
      serviceCardBlocks: [],
    }
  },
  computed: {
    serviceTypeFeatureEnabled() {
      return isServiceTypeFeatureOn(this.orderSettings)
    },
    displayBlocks() {
      const blocks = [
        {
          id: 'default',
          linear: this.linear_sections,
          bucket: this.bucket_sections,
          isTableView: !!this.tableViewByBlock.default,
          linearOffset: 0,
          bucketOffset: 0,
        },
      ]
      let linearOffset = this.linear_sections.length
      let bucketOffset = this.bucket_sections.length
      this.serviceCardBlocks.forEach(card => {
        blocks.push({
          id: card.id,
          cardName: card.cardName,
          serviceTypeName: card.serviceTypeName,
          linear: card.linear,
          bucket: card.bucket,
          isTableView: !!this.tableViewByBlock[card.id],
          linearOffset,
          bucketOffset,
        })
        linearOffset += card.linear.length
        bucketOffset += card.bucket.length
      })
      return blocks
    },
  },
  watch: {
    serviceTypeFeatureEnabled() {
      this.buildServiceCardBlocks()
    },
  },
  created() {
    this.id = this.$route.params.id
  },
  async mounted() {
    this.dataLoading = true
    try {
      this.readServiceTypeGateFromStorage()
      await this.readDataforCity()
      await this.readDataforZone()
      await this.fetchRateCardDetails()
      this.setDropdownStyles()
      this.refreshServiceTypeGateFromApi()
    } catch (e) {
      this.convertAndNotifyError(e)
    } finally {
      this.dataLoading = false
    }
  },
  methods: {
    onBlockTableView(blockId, val) {
      let enabled = false
      if (typeof val === 'boolean') {
        enabled = val
      } else if (val && typeof val === 'object' && val.target) {
        enabled = !!val.target.checked
      }
      this.$set(this.tableViewByBlock, blockId, enabled)
      if (!enabled) {
        this.setDropdownStyles()
      }
    },
    readServiceTypeGateFromStorage() {
      try {
        this.orderSettings = localStorage.getItem('order_setting')
          ? JSON.parse(localStorage.getItem('order_setting'))
          : {}
      } catch (e) {
        this.orderSettings = {}
      }
    },
    refreshServiceTypeGateFromApi() {
      OrderSettingsRepository.getOrderSettingsResource()
        .then(({ data }) => {
          if (data && data.data) {
            this.orderSettings = data.data
            localStorage.setItem('order_setting', JSON.stringify(data.data))
          }
        })
        .catch(() => {})
    },
    async readDataforCity() {
      try {
        this.CityList = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityDropdownListMultilingual()).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(this.CityList))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforZone() {
      try {
        this.ZoneList = localStorage.getItem('zone_list') ? JSON.parse(localStorage.getItem('zone_list')) : (await ResourceRepository.getZoneListDropdown()).data.data
        if (!localStorage.getItem('zone_list')) localStorage.setItem('zone_list', JSON.stringify(this.ZoneList))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchRateCardDetails() {
      try {
        const { data } = await ResourceBusinessSettingRepository.getMerchantRateCard(this.id)
        this.rateCardName = data.data.card_name
        this.rows = data.data
        const defaultSections = this.mapFormDataToSections(this.cloneFormData(this.rows.form_data))
        this.linear_sections = defaultSections.linear
        this.bucket_sections = defaultSections.bucket
        this.buildServiceCardBlocks()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    cloneFormData(formData) {
      try {
        return JSON.parse(JSON.stringify(formData || []))
      } catch (e) {
        return []
      }
    },
    buildServiceCardBlocks() {
      if (!this.rows) {
        this.serviceCardBlocks = []
        return
      }
      const serviceCards = this.rows.service_type_rate_cards || []
      this.serviceCardBlocks = serviceCards.map((card, cardIndex) => {
        const serviceName = (card.service_type && card.service_type.name) ? card.service_type.name : ''
        let serviceKey = `idx-${cardIndex}`
        if (card.service_type && card.service_type.id) {
          serviceKey = String(card.service_type.id)
        } else if (card.id) {
          serviceKey = String(card.id)
        }
        const extra = this.mapFormDataToSections(this.cloneFormData(card.form_data), {
          is_service_type: true,
          service_type_name: serviceName,
          service_type_key: serviceKey,
        })
        return {
          id: `service-${serviceKey}-${card.id || cardIndex}`,
          cardName: card.card_name || '',
          serviceTypeName: serviceName || '',
          linear: extra.linear,
          bucket: extra.bucket,
        }
      })
    },
    groupOriginCities(cities) {
      const groups = [];
      (cities || []).forEach(city => {
        const existing = groups.find(group => group.from_city === city.from_city
          && group.from_type === city.from_type
          && group.to_type === city.to_type
          && group.is_bidirectional === city.is_bidirectional)
        if (existing) {
          if (existing.to_cities.indexOf(city.to_city) === -1) {
            existing.to_cities.push(city.to_city)
          }
        } else {
          groups.push({
            from_type: city.from_type,
            from_city: city.from_city,
            to_type: city.to_type,
            to_city: city.to_city,
            is_bidirectional: city.is_bidirectional,
            to_cities: [city.to_city],
          })
        }
      })
      return groups
    },
    mapFormDataToSections(formData, meta = {}) {
      const linear = (formData || []).filter(section => section.section_type === 'linear')
      linear.forEach((_, indexn) => {
        if (meta.is_service_type) {
          linear[indexn].is_service_type = true
          linear[indexn].service_type_name = meta.service_type_name || ''
          linear[indexn].service_type_key = meta.service_type_key
          linear[indexn].show_service_type = indexn === 0
        }
        linear[indexn].cities = this.groupOriginCities(linear[indexn].cities)
      })
      const bucket = (formData || []).filter(section => section.section_type === 'bucket')
      bucket.forEach((_, indexn) => {
        if (meta.is_service_type) {
          bucket[indexn].is_service_type = true
          bucket[indexn].service_type_name = meta.service_type_name || ''
          bucket[indexn].service_type_key = meta.service_type_key
          bucket[indexn].show_service_type = linear.length === 0 && indexn === 0
        }
        bucket[indexn].cities = this.groupOriginCities(bucket[indexn].cities)
      })
      return { linear, bucket }
    },
    onSubmit() {
      if (this.is_update) {
        this.rateCardName = this.rateCardName.replaceAll('Rate Card - ', '')
      }
      this.linear_sections.forEach((n, index) => {
        const { amount } = n
        // eslint-disable-next-line camelcase
        const new_amount = {}
        if (amount.delivery_method === 'per_kg') {
          new_amount.delivery_method = 'per_kg'
          new_amount.delivery_weight_margin = amount.delivery_weight_margin
          new_amount.delivery_weight_margin_rate = amount.delivery_weight_margin_rate
          new_amount.delivery_weight_after_margin_rate = amount.delivery_weight_after_margin_rate
        }
        if (amount.return_method === 'per_kg') {
          new_amount.return_method = 'per_kg'
          new_amount.return_weight_margin = amount.return_weight_margin
          new_amount.return_weight_margin_rate = amount.return_weight_margin_rate
          new_amount.return_weight_after_margin_rate = amount.return_weight_after_margin_rate
        }
        if (amount.delivery_method === 'per_order') {
          new_amount.delivery_method = 'per_order'
          new_amount.delivery_rate = amount.delivery_rate
        }
        if (amount.return_method === 'per_order') {
          new_amount.return_method = 'per_order'
          new_amount.return_rate = amount.return_rate
        }
        // eslint-disable-next-line camelcase
        this.linear_sections[index].amount = new_amount
      })

      if (this.rateCardName === '' || this.rateCardName === null) {
        this.showErrorMessage('Please Enter an Rate Card Name')
      } else if (this.bucket_sections.length === 0) {
        // eslint-disable-next-line arrow-body-style
        const linearSections = this.linear_sections.map(n => {
          const mappedCities = []
          // eslint-disable-next-line arrow-body-style
          n.cities.forEach(m => {
            m.to_cities.forEach(o => {
              mappedCities.push({
                from_type: m.from_type,
                from_city: m.from_city,
                to_type: m.to_type,
                to_city: o,
                is_bidirectional: m.is_bidirectional,
              })
            })
          })
          return {
            section_type: n.section_type,
            amount: n.amount,
            cities: mappedCities,
          }
        })
        const all = linearSections

        const rateCard = {
          rate_card_general_details: {
            card_name: `Rate Card - ${this.rateCardName}`,
          },
          sections: all,
        }
        this.handleSubmit(rateCard)
      } else {
        // eslint-disable-next-line arrow-body-style
        const linearSections = this.linear_sections.map(n => {
          const mappedCities = []
          // eslint-disable-next-line arrow-body-style
          n.cities.forEach(m => {
            m.to_cities.forEach(o => {
              mappedCities.push({
                from_type: m.from_type,
                from_city: m.from_city,
                to_type: m.to_type,
                to_city: o,
                is_bidirectional: m.is_bidirectional,
              })
            })
          })
          return {
            section_type: n.section_type,
            amount: n.amount,
            cities: mappedCities,
          }
        })
        const bucketSections = this.bucket_sections.map(n => {
          const mappedCities = []
          n.cities.forEach(m => {
            m.to_cities.forEach(o => {
              mappedCities.push({
                from_type: m.from_type,
                from_city: m.from_city,
                to_type: m.to_type,
                to_city: o,
                is_bidirectional: m.is_bidirectional,
              })
            })
          })
          return {
            section_type: n.section_type,
            amount: n.amount,
            cities: mappedCities,
          }
        })
        const all = linearSections.concat(bucketSections)

        const rateCard = {
          rate_card_general_details: {
            card_name: `Rate Card - ${this.rateCardName}`,
          },
          sections: all,
        }
        this.handleSubmit(rateCard)
      }
    },
    setDropdownStyles() {
      this.$nextTick(() => {
        document.querySelectorAll('.vs__selected-options , .vs__actions').forEach(n => {
          // eslint-disable-next-line no-unused-vars
          n.addEventListener('click', e => {
            const dropdownElements = document.querySelectorAll('.vs__dropdown-option')
            dropdownElements.forEach(item => {
              // eslint-disable-next-line no-param-reassign
              item.style.pointerEvents = 'none'
            })
          })
        })
      })
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';

:root {
--bucketcolor: #6f57e8
}

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
@media (max-width: 767px) {
  .rate-card-toolbar-actions {
    margin-left: 0;
    justify-content: flex-start !important;
    margin-top: 0.5rem;
  }
  .mobile-width-fix {
    max-width: 100%;
    flex-basis: 100%;
  }
}
.rate-card-toolbar ::v-deep .form-group label {
  font-size: 0.8125rem;
  color: #6e6b7b;
  margin-bottom: 0.35rem;
}
.rate-card-toolbar-row {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  padding-left: 1px;
  padding-right: 1px;
}
.rate-card-toolbar ::v-deep .vs__dropdown-toggle {
  min-height: 38px;
}
.rate-card-toolbar-actions {
  min-height: 38px;
}
.rate-card-toolbar-actions ::v-deep .custom-control {
  margin-top: 0;
  margin-bottom: 0;
}
.rate-card-kind-badge {
  margin-left: 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
}
.service-type-row {
  margin-top: 0.75rem;
}
.rate-card-block-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6e6b7b;
  margin-bottom: 0.35rem;
}
</style>
